import GameCard from "../gamecard/gameCard.jsx";
import AdSideBar from "../ad/adSideBar";

export default function cardGrid(allGames) {
    allGames = allGames.allGames
    return (
        <div className="grid grid-cols-3 xs:grid-cols-2 sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-6 gap-2 sm:gap-4 md:gap-5">
            {allGames.map((game, index) =>
                game.title === "ad" ? (
                    <AdSideBar key={index} />
                ) : (
                    <GameCard key={game.id} game={game} />
                )
            )}
        </div>)
}


